export default __webpack_public_path__ + "static/media/caja-18.6a1ada26.svg";